export default "__VITE_ASSET__D$iU7nGF__"